import { render, staticRenderFns } from "./ProductIntro.vue?vue&type=template&id=54a941a8&scoped=true&"
import script from "./ProductIntro.vue?vue&type=script&lang=ts&"
export * from "./ProductIntro.vue?vue&type=script&lang=ts&"
import style0 from "./ProductIntro.vue?vue&type=style&index=0&id=54a941a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a941a8",
  null
  
)

export default component.exports